import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface InitialState {
  section: string, 
  corrections: any[], 
  selectedFile: any,
  isServerCorrecting: boolean, 
  isCorrectionsOpened: boolean
}

const initialState: InitialState = {
  section: '', 
  corrections: [], 
  selectedFile: null,
  isServerCorrecting: false, 
  isCorrectionsOpened: false, 
};

export const correctFileSlice = createSlice({
  name: 'correctFile',
  initialState,
    reducers: {
    setSection: (state, action: PayloadAction<string>) => {
        state.section = action.payload
    },
    setCorrections: (state, action: PayloadAction<any>) => {
        state.corrections = action.payload 
    },
    setSelectedFile: (state, action: PayloadAction<any>) => {
      state.selectedFile = action.payload 
    },
    setIsServerCorrecting: (state, action: PayloadAction<any>) => {
      state.isServerCorrecting = action.payload 
    },
    setIsCorrectionsOpened: (state, action: PayloadAction<boolean>) => {
      state.isCorrectionsOpened = action.payload 
    },
    resetCorrectFile: (state) => { 

      state.section = '';
      state.corrections = []; 
      state.selectedFile = null; 
      state.isServerCorrecting = false; 
      state.isCorrectionsOpened = false; 

    } 
  },
});

export const {
  setSection, 
  setCorrections, 
  setSelectedFile, 
  setIsServerCorrecting, 
  setIsCorrectionsOpened, 
  resetCorrectFile
} = correctFileSlice.actions;

export default correctFileSlice.reducer;